import _ from "lodash";
import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_HR_GET_USER_ROLES_DATA_BY_CONTRACT,
  MY_HR_USER_ROLES_DATA_BY_CONTRACT_SUBSCRIPTION,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrUserRolesDataByContract = ({
  contract,
}: {
  contract: string;
}) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_USER_ROLES_DATA_BY_CONTRACT,
    {
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      skip: !contract,
      variables: {
        contract,
      },
    },
  );

  useSubscription(MY_HR_USER_ROLES_DATA_BY_CONTRACT_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    skip: !contract,
    variables: {
      contract,
    },
    onData: ({ client, data }) => {
      client.writeQuery({
        query: MY_HR_GET_USER_ROLES_DATA_BY_CONTRACT,
        data: data.data,
      });
    },
  });

  type UserRoleData = {
    product: string;
    role: string;
    [key: string]: any;
  };

  let result: UserRoleData[] = data?.userRolesDataByContract || [];

  let roles = result.map((item: UserRoleData) => {
    return `${item.product}.${item.role}`;
  });

  const hasRole = (allowedRoles: string[], notAllowedRoles?: string[]) => {
    if (!allowedRoles) return false;
    let isAllowedExist = _.intersectionBy(allowedRoles, roles);
    if (isAllowedExist.length === 0) {
      return false;
    }
    let isNotAllowedExist = [];
    if (notAllowedRoles) {
      isNotAllowedExist = _.intersectionBy(notAllowedRoles, roles);
      return isNotAllowedExist.length > 0 ? false : true;
    }
    return isAllowedExist.length > 0 ? true : false;
  };

  return {
    data: result,
    roles,
    hasRole,
    loading,
    error,
    refetch,
  };
};

export default useMyHrUserRolesDataByContract;
